import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";

// Tableau de bord : compte à rebours J-n + consentements parentaux manquants (événement Jeux Martiaux OUVERT seulement ; alerte forte à J-14).
export function ConsentCountdownCard() {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/jm/consent-countdown").then((r) => setEvents(r.data.events || [])).catch(() => setEvents([])); }, []);
  if (!events.length) return null;
  return events.map((e) => {
    const tone = e.blocking ? "border-red-500/60 bg-red-500/[0.08]" : e.critical ? "border-amber-500/60 bg-amber-500/[0.07]" : "border-zinc-700 bg-zinc-900/40";
    return (
      <div key={e.competition_id} className={`mx-6 md:mx-8 lg:mx-10 mt-6 rounded-xl border p-4 flex flex-wrap items-center gap-4 ${tone}`} data-testid={`consent-countdown-${e.competition_id}`}>
        <div className="text-center min-w-[72px]">
          <div className={`text-3xl font-black leading-none ${e.critical ? "text-amber-300" : "text-zinc-100"}`} data-testid="consent-countdown-days">J-{e.days_left}</div>
          <div className="text-[9px] uppercase tracking-[0.2em] text-zinc-500 mt-1">{e.date}</div>
        </div>
        <div className="flex-1 min-w-[240px]">
          <p className="text-[10px] uppercase tracking-[0.2em] text-amber-300 font-semibold">Jeux Martiaux · consentements parentaux</p>
          <h3 className="text-zinc-100 font-bold mt-0.5" data-testid="consent-countdown-title">
            {e.missing ? `${e.missing} consentement${e.missing > 1 ? "s" : ""} signé${e.missing > 1 ? "s" : ""} manquant${e.missing > 1 ? "s" : ""} sur ${e.minors} mineur${e.minors > 1 ? "s" : ""}` : `Tous les consentements des ${e.minors} mineur(s) sont reçus ✔`}
          </h3>
          <p className="text-xs text-zinc-400 mt-0.5">
            {e.blocking ? "⛔ Moins de 3 jours : aucun mineur sans formulaire signé ne combat." : e.critical ? "⚠️ J-14 franchi : relance les parents maintenant (Boîte d'envoi)." : "Rappel automatique hebdomadaire préparé dans la Boîte d'envoi."}
            {e.missing_names?.length > 0 && <span className="text-zinc-500"> · {e.missing_names.join(", ")}{e.missing > e.missing_names.length ? "…" : ""}</span>}
          </p>
        </div>
        <button onClick={() => navigate("/app/mini-competitions")} className="shrink-0 px-3 py-1.5 rounded-lg bg-amber-500 hover:bg-amber-400 text-black text-xs font-semibold" data-testid="consent-countdown-open">
          Suivi des consentements →
        </button>
      </div>
    );
  });
}
